"use strict";

exports.__esModule = true;
exports.flexbox = void 0;

var _core = require("../core");

var config = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  flex: true,
  flexFlow: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: {
    property: 'flexBasis',
    scale: 'sizes'
  },
  justifySelf: true,
  alignSelf: true,
  order: true,
  placeItems: true,
  placeContent: true,
  placeSelf: true
};
config.flexDir = config.flexDirection;
var flexbox = (0, _core.system)(config);
exports.flexbox = flexbox;